import React, { useRef, useEffect, useState, useMemo }  from "react";
import DefaultSelect from "../More/DefaultSelect";
import ProductSection from "../../components/Product/ProductSection";
import CategoryTab from "../../components/CategoryTab/CategoryTab"
import PaginationSection from "../../components/Product/Pagination";
import instance from "../../services/services";
import { BRAND_EXCLUDE_CATEGORY_LIST_URL } from "../../utils/urls";
import useUserStore from "../../store/userStore";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";

function CinemaPageSecDetail(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const pageRef = useRef(); // 전체 페이지를 위한 ref 추가
  const location = useLocation();
  const { member_seq } = useUserStore(state => state.userInfo);
  const [products, setProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태 추가
  const [currentSort, setCurrentSort] = useState("page_view"); // 정렬 기준 상태 추가 (인기순)
  const itemsPerPage = 30; // 페이지당 상품 수 (고정값)
  const [loading, setLoading] = useState(true); // 로딩 상태 추가
  const [categoryInfo, setCategoryInfo] = useState([]);

  const urlParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      title: searchParams.get('title') || '',
      sub: searchParams.get('sub') || '',
      mainCategory: searchParams.get('mainCategory') || location.state?.mainCategory || 'CINEMA',
      previousTitle: searchParams.get('previousTitle') || location.state?.previousTitle || '',
      selectedCategoryCode: location.state?.selectedCategoryCode || ''
    };
  }, [location.search, location.state]);

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 상단으로 스크롤
  };

  // 화살표 클릭 핸들러
  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  // 정렬 변경 핸들러
  const handleSortChange = (value) => {
    setCurrentSort(value);
    setCurrentPage(1); // 정렬 변경 시 첫 페이지로 이동
  };

  // breadcrumb 클릭 핸들러 추가
  const handleBreadcrumbClick = (level) => {
    switch(level) {
      case 'home':
        navigate('/');
        break;
      case 'mainCategory':
        // 메인 카테고리 페이지로 이동
        const categoryData1 = urlParams.selectedCategoryCode?.slice(0, 4) || '';
        navigate(`/category/cinemaPage?title=${urlParams.mainCategory}&category_code=${categoryData1}`, {
          state: {
            mainCategories: location.state?.mainCategories
          }
        });
        break;
      case 'previousTitle':
        // 이전 페이지(CinemaPageSec)로 이동 시 원래 파라미터 보존
        navigate(`/category/cinemaPageSec?title=${urlParams.previousTitle}&mainCategory=${urlParams.mainCategory}&category_code=${urlParams.selectedCategoryCode}&sub=${urlParams.sub}`, {
          state: {
            mainCategories: location.state?.mainCategories,
            previousTitle: urlParams.previousTitle,
            selectedCategoryCode: urlParams.selectedCategoryCode,
            subCategories: location.state?.subCategories,  // 반드시 전달!
            allSubCategories: location.state?.allSubCategories  // 이 부분도 있으면 추가
          }
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await instance.post(BRAND_EXCLUDE_CATEGORY_LIST_URL, {
          category_code: urlParams.sub,
          member_seq: member_seq || '',
          offset: currentPage, // 현재 페이지 전달
          searchSort: currentSort, // 정렬 기준 전달
          limit: itemsPerPage // 페이지당 아이템 수 전달
        });

        setCategoryInfo(response.data.data.categoryInfo);
        
        
        // 카테고리 객체에서 첫 번째 키를 가져옴 (예: '000200030001')
        const categoryKey = Object.keys(response.data.data.category)[0];
        
        if (categoryKey && response.data.data.category[categoryKey]) {
          // 해당 카테고리의 데이터 배열과 개수 추출
          const categoryData = response.data.data.category[categoryKey];
          setProducts(categoryData.data || []);
          setTotalCount(parseInt(categoryData.cntRow || "0")); // 문자열을 정수로 변환
        } else {
          setProducts([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error('카테고리 데이터 가져오기 오류:', error);
      } finally {
        setLoading(false);
      }
    };  
    fetchData();
  }, [urlParams.sub, member_seq, currentPage, currentSort]); // 페이지나 정렬이 바뀔 때마다 데이터 다시 불러오기

  const BeforeContent = () => (
    <div className="auth_find">
        <div className="product_total">
            {t('product_total_count', {count: totalCount})}
        </div>
        <DefaultSelect 
          defaultValue={currentSort}
          onChange={handleSortChange}
        />
    </div>
  );

  const AfterContent = () => (
    <div className="pagination_wrap">
        <PaginationSection
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onArrow={handleArrowClick}
        />
    </div>
  );

  return(
    <div ref={pageRef}>
      <section className="prod_section">
        <div 
          className="product_banner cate_brand"
          style={{backgroundImage:`url(${window.innerWidth > 768 ? categoryInfo?.pc_img_url : categoryInfo?.mobile_img_url})`}}
        >
          <div className="inner">
            <ul className="bread_crumb">
              <li className="group_item" style={{cursor: 'pointer'}} onClick={() => handleBreadcrumbClick('home')}>
                <p>HOME</p>
              </li>
              <li className="group_item" style={{cursor: 'pointer'}} onClick={() => handleBreadcrumbClick('mainCategory')}>
                <p>{urlParams.mainCategory}</p>
              </li>
              <li className="group_item" style={{cursor: 'pointer'}} onClick={() => handleBreadcrumbClick('previousTitle')}>
                <p>{urlParams.previousTitle}</p>
              </li>
              <li className="group_item active">
                <p>{urlParams.title}</p>
              </li>
            </ul>
            
            <div className="product_tit">
              <h4 className="tit">CINEMA</h4>
              <p className="sub">{categoryInfo?.cate_comment}</p>
            </div>

            {location.state?.mainCategories && location.state.mainCategories.length > 0 && (
              <CategoryTab 
                categoryNames={location.state.mainCategories} 
                activeTitle={urlParams.previousTitle}
                selectedCategoryCode={urlParams.selectedCategoryCode}
                mainCategory={urlParams.mainCategory}
                title={urlParams.previousTitle}
              />
            )}
          </div>
        </div>

        <div className="inner main_prod_list cate_container gap_64">
          {/* 상품 그리드, 더보기 버튼 */}
          <div>
            <div className="brand_top_tab">
              <div className="brand_section_title">
                {urlParams.title}
              </div>
            </div>

            <div className="p0">
              {loading ? (
                <div className="loading-overlay">
                  <div className="loading">로딩 중...</div>
                </div>
              ) : products.length > 0 ? (
                <ProductSection
                  products={products}
                  showTabs={false}
                  showMoreButton={false}
                  beforeContent={<BeforeContent />}
                  afterContent={<AfterContent />}
                  useSwiper={false}
                />
              ) : (
                <div className="no_result">
                  <p>{t('no_product_found')}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CinemaPageSecDetail;
